<template>
    <div>
        <b-loading :is-full-page="true" :active.sync="isFetchingDepartments" :can-cancel="false"></b-loading>
        <h3 class="title is-3">Manage Department</h3>
        <hr />
        <div class="columns">
            <div class="column is-2">
                <div class="field">
                    <label class="label is-small">Department</label>
                    <div class="control">
                        <input type="text" v-model="department.name" class="input is-small" v-validate="'required'" name="Department name" />
                        <span style="font-size:12px" class="has-text-danger">{{ errors.first('Department name') }}</span>
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label is-small">Desc</label>
                    <div class="control">
                        <input type="text" v-model="department.desc" class="input is-small" />
                    </div>
                </div>
            </div>
        </div>
        <button :class="buttonSave" @click="saveDepartment">{{createOrEdit}}</button>
        &nbsp;
        <button v-show="createOrEdit == 'Update'" class="button is-small" @click="cancelEdit">Cancel</button>        
        <div style="clear:both"></div>
        <br />
        <b-table :data="departments"
                    :bordered="true"
                    :striped="true"
                    :narrowed="true"
                    :hoverable="true"
                    :mobileCards="true">
            <template slot-scope="item">
                <b-table-column field="departmentId" class="table-column-content-is-small" label="ID">
                    {{item.row.departmentId}}
                </b-table-column>
                <b-table-column field="departmentId" class="table-column-content-is-small" label="Name">
                    {{item.row.name}}
                </b-table-column>
                <b-table-column field="departmentId" class="table-column-content-is-small" label="Desc.">
                    {{item.row.desc}}
                </b-table-column>
                <b-table-column>
                    <button class="button is-small is-warning" @click="editDepartment(item.row.departmentId)">Edit</button> &nbsp;
                    <button class="button is-small is-danger" @click="deleteDepartment(item.row.departmentId)">Delete</button>
                </b-table-column>
            </template>
        </b-table>
        <div class="modal is-active" v-show="showDeleteModal">
          <div class="modal-background"></div>
          <div class="modal-card">
              <header class="modal-card-head">
              <p class="modal-card-title">Delete Department</p>
              <button class="delete" aria-label="close"></button>
              </header>
              <section class="modal-card-body">
              <!-- Content ... -->
              Are you sure do you want to delete this permanently? 
              </section>
              <footer class="modal-card-foot" style="justify-content:flex-end">
              <button :class="buttonDelete" @click="deletePermanently">Yes</button>
              <button class="button is-small" @click="cancel">No</button>
              </footer>
          </div>
        </div>
    </div>
</template>

<script>
import axios from "axios"
import AppToast from '../frontend/appToast'
import AppButton from '../frontend/appButton'

const appToast = new AppToast()
const appButton = new AppButton()

export default {
  data: () => ({
        createOrEdit: "Create",
        showDeleteModal: false,
        department: {},
        departments: [],
        isFetchingDepartments: false,
        buttonSave: appButton.isLoadingSuccess(false),
        buttonDelete: appButton.isLoadingDanger(false)
  }),
  created(){
      this.getDepartments()
  },
  methods: {
    saveDepartment() {
        this.$validator.validateAll().then(result =>{
            if(result){
                this.buttonSave = appButton.isLoadingSuccess(true)
                const departmentId = this.department.departmentId
                if(departmentId){ // Edit
                    axios.put(`api/departments/${departmentId}`, this.department).then(response=>{
                        appToast.success(response.data)
                    }).catch(error=>{
                        console.log(error)
                    }).then(()=>{
                        this.default()
                    })
                }else{
                    axios.post(`api/departments`, this.department).then(response=>{
                        appToast.success(response.data)
                    }).catch(error=>{
                        console.log(error)
                    }).then(response=>{
                        this.default()
                    })
                }
            }
        })
    },
    getDepartments(){
        this.isFetchingDepartments = true
        axios.get('api/departments').then(response=>{
            this.departments = response.data
        }).catch(error=>{
            console.log(error)
        }).then(()=>{
            this.isFetchingDepartments = false
        })
    },
    editDepartment(id){
        axios.get(`api/departments/${id}`).then(response=>{
            this.department = response.data
            this.createOrEdit = "Update"
        }).catch(error=>{
            console.log(error)
        })
    },
    deleteDepartment(id){
        this.showDeleteModal = true
        this.department.departmentId = id
    },
    deletePermanently(){
        if(this.showDeleteModal){
                    this.buttonDelete = appButton.isLoadingDanger(true)
            const departmentId = this.department.departmentId
            if(departmentId){
                axios.delete(`api/departments/${departmentId}`).then(response=>{
                    appToast.success(response.data)
                }).catch(error=>{
                    console.log(error)
                }).then(()=>{
                    this.default()
                })
            }
        }
    },
    cancel(){
        this.showDeleteModal = false
    },
    default(){
        this.createOrEdit = "Create"
        this.department = {}
        this.showDeleteModal = false
        this.getDepartments()
        this.buttonSave = appButton.isLoadingSuccess(false)
        this.buttonDelete = appButton.isLoadingDanger(false)

        this.$nextTick(() => {
            this.$validator.reset();
        });
    },
    cancelEdit(){
        this.default()
    }
  }
};
</script>

